import { render, staticRenderFns } from "./resume-languages.vue?vue&type=template&id=3b18cbb6&scoped=true"
import script from "./resume-languages.vue?vue&type=script&lang=js"
export * from "./resume-languages.vue?vue&type=script&lang=js"
import style0 from "./resume-languages.vue?vue&type=style&index=0&id=3b18cbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18cbb6",
  null
  
)

export default component.exports